export const HEADER_TEXT = 'Welcome to Shepherd';
export const SUBHEADER_TEXT = 'An app based in your Google Calendar and Google Meet to help you and your team run more productive meetings';
export const BUTTON_TEXT = 'Continue with Google';
